export default 
{
	"progressbar-page-title": "Strona",
	"name-suffix": "Przyrostek",
	"fileupload-desc-progress-message": "Przesyłanie {postęp}",
	"required-if-greater-than-or-equal": "{property} jest wymagane, gdy {compareSource} jest większe niż lub równe {compareValue}.",
	"powered-by-cognito": "Stworzony przez Cognito Forms.",
	"form-name-default": "Bez tytułu",
	"field-choice-defaults": "Pierwszy wybór|Drugi wybór|Trzeci wybór",
	"additional-fee-default-label": "Dodatkowa opłata",
	"authenticated-save-and-resume-email-dialog": "Wyślij link e-mailem i wróć do formularza, aby dokończyć przesyłanie danych.",
	"string-length-between": "{property} musi wynosić {min} i {max} znaków.",
	"update-button-text": "Aktualizacja",
	"address-zip-code-invalid": "Kod pocztowy musi być sformatowany jako #####-####.",
	"required-if-greater-than": "{property} jest wymagane, gdy {compareValue} jest większe niż {compareSource}.",
	"compare-before": "{property} musi być przed {compareSource}.",
	"compare-after": "{property} musi być po {compareSource}.",
	"unsupported-browser-message": "Używasz nieobsługiwanej przeglądarki. {a}Kliknij tutaj {/a}, aby uaktualnić.",
	"shared-entry-email-subject": "Wspólne Link",
	"send-button-text": "Wysłać",
	"venmo-help-text": "Połącz się z Venmo, aby kontynuować płatność.",
	"field-repeatingsection-item-label": "Element",
	"save-and-resume-email-not-sent-message": "Był problem.",
	"credit-card-cvv": "CVV",
	"range-at-least": "{property} musi być co najmniej {min.}.",
	"entry-notification-full-entry-detail-link": "Zobacz wszystkie szczegóły na cognitoforms.com.",
	"element-label-website": "Strona internetowa",
	"element-label-signature": "Podpis",
	"paypal-help-text": "Połącz się z PayPal, aby kontynuować płatność.",
	"card-on-file-agreement-validation": "Musisz wyrazić zgodę na zapisanie swojej karty do przyszłych transakcji.",
	"marketing-button-4": "Zbuduj Swój Własny Za Darmo",
	"field-datepicker-now": "Teraz",
	"save-and-resume-email-resume-button": "Wznów teraz",
	"field-datepicker-next-month": "Następny miesiąc",
	"quantity-remaining-text": "pozostały",
	"payment-declined": "Płatność odrzucona",
	"required-if-before": "{property} jest wymagane, gdy {compareValue} jest przed {compareSource}.",
	"this-comma-that": "{0}, {1}",
	"compare-less-than": "{property} musi być mniejsza niż {compareSource}.",
	"entry-admin-link": "",
	"required-many": "{0} są wymagane.",
	"save-and-resume-multiple-days-expiration-email-message": "Użyj poniższego linku, aby wrócić do formy w ciągu {days} dni do zakończenia swojego zgłoszenia.",
	"string-length-at-least": "{property} musi mieć co najmniej {min} znaków.",
	"credit-card-number": "Numer karty kredytowej",
	"range-on-or-before": "{property} musi być w lub przed {maks.}.",
	"required-one": "{0} jest wymagane.",
	"fileupload-max-file-count-exceeded-message": "Tylko {maxFileCount} plików może być przesłanych.",
	"order-transaction-details-header": "Szczegóły transakcji",
	"field-spinner-increase": "Zwiększać",
	"payment-processing-fees": "Opłaty manipulacyjne",
	"payment": "Płatność",
	"field-choice-other-fill-in": "Inne",
	"shared-entry-email-message": "Wpis został wspólnie z Tobą.",
	"shared-entry-workflow-link": "Zobacz formularz.",
	"required-if-exists": "{property} jest wymagane, gdy {compareSource} jest określony.",
	"concurrent-conflict-toast-message": "Przesyłanie nie powiodło się, ponieważ zmieniły się informacje w formularzu. Sprawdź i spróbuj ponownie.",
	"secured-by-paypal": "Zabezpieczone przez",
	"range-on-or-after": "{property} musi być w lub po {min.}.",
	"payment-amount-due": "Należna kwota",
	"required-name-first-and-last": "Imię i nazwisko jest wymagane",
	"required": "{property} jest wymagane.",
	"string-format-alphabetic": "{property} musi zawierać tylko litery.",
	"quantity-limit": "{property} ilość przekroczona.",
	"field-spinner-decrease": "Zmniejszać",
	"field-repeatingsection-add-link-text": "Dodaj",
	"fileupload-max-size-exceeded-message": "Tylko pliki mniejsze niż {maxSize} MB mogą być przesłane.",
	"credit-card-expiration": "MM/RR",
	"field-signature-notcaptured": "Nie Zdobył",
	"field-ratingscale-satisfied-unsatisfied-label": "Zadowolony/Niezadowolony",
	"range-between": "{property} musi wynosić {min} i {maks.}.",
	"field-ratingscale-agree-disagree-label": "Zgadzam sie/Nie zgadzam sie",
	"back-button-text": "Poprzednia strona",
	"address-country": "Kraj",
	"order-not-found": "Nie znaleziono informacji o zamówieniu.",
	"field-ratingscale-satisfied-unsatisfied-options": "Bardzo niezadowolony/a|Niezadowolony/a|Obojętny(a)|Zadowolony/a|Bardzo zadowolony/a",
	"entry-notification-entry-details-header": "Szczegóły wpisu",
	"FALSE": "Fałsz",
	"compare-greater-than-or-equal": "{property} musi być większa lub równa {compareSource}.",
	"receipt-notification-order-details-desc-header": "Opis",
	"order-method-label": "Metoda",
	"order-total-label": "Suma zamówienia",
	"invalid-shared-link": "Nieprawidłowy Shared link",
	"fileupload-zero-byte-file-message": "Pliki zero bajtowe nie mogą być przesłane.",
	"range-at-most": "{property} musi być najwyżej {maks.}.",
	"format-integer": "####",
	"order-date-label": "Data",
	"fileupload-dropzone-message": "lub przeciągnij pliki tutaj.",
	"shared-entry-view-link": "Zobacz udostępnione wpis.",
	"format-currency": "# ###,## zł",
	"string-length-at-most": "{property} musi mieć co najwyżej {max} znaków.",
	"entry-confirmation-footer-tagline": "Stwórz swój własny formularz płatności z",
	"submit-button-text": "Prześlij",
	"marketing-msg": "Łatwe tworzenie zaawansowanych formularzy.",
	"required-if-on-or-after": "{property} jest wymagane, gdy {compareValue} jest w lub przed {compareSource}.",
	"card-on-file-agreement": "Wyrażam zgodę na zapisanie mojej karty do przyszłych transakcji.",
	"signature-draw": "rysować",
	"address-zip-code": "Kod pocztowy",
	"compare-on-or-after": "{property} musi być w lub po {compareSource}.",
	"required-if-less-than-or-equal": "{property} jest wymagane, gdy {compareValue} jest mniejsze lub równe {compareSource}.",
	"field-datepicker-next-year": "Następny rok",
	"change-button": "zmieniać",
	"fileupload-desc-size-in-bytes-message": "{size} bajtów",
	"card-tab": "Karta ",
	"order-billing-info-header": "Dane płatności",
	"entry-email-view-details-text": "Zobacz pełny wpis w CognitoForms.com.",
	"save-and-resume-one-day-expiration-email-message": "Użyj poniższego linku, aby wrócić do formy w ciągu następnego dnia, aby zakończyć składanie.",
	"credit-card-authentication-failed": "Uwierzytelnienie karty nie powiodło się.",
	"compare-less-than-or-equal": "{property} musi być mniejsza niż lub równa {compareSource}.",
	"receipt-notification-order-details-balance-due": "Saldo do zapłaty",
	"save-and-resume-multiple-days-expiration-message": "Kopiowanie lub e-mail link poniżej i powrót do formularza w ciągu {days} dni, aby zakończyć twoje zgłoszenie.",
	"processing-fee-calculating-message": "Obliczenia",
	"receipt-notification-trx-details-method": "Metoda",
	"field-choice-no-match": "Brak dopasowań",
	"fileupload-invalid-file-type-message": "Tylko {allowedTypes} pliki mogą być przesłane.",
	"receipt-notification-trx-details-date": "Data",
	"credit-card-authorization": "Autoryzacja karty",
	"address-line1": "Linia adresu 1",
	"required-if-not-exists": "{property} jest wymagane, gdy {compareSource} nie jest określony.",
	"required-if-not-equal": "{property} jest wymagane, gdy {compareSource} nie jest {compareValue}.",
	"marketing-button-2": "Zbuduj Swój Własny Za Darmo",
	"receipt-notification-billing-info-header": "Dane płatności",
	"required-if-after": "{property} jest wymagane, gdy {compareValue} jest po {compareSource}.",
	"element-label-name": "Nazwa",
	"required-if-equal": "{property} jest wymagane, gdy {compareSource} jest {compareValue}.",
	"connected-to-paypal": "Połączono z PayPalem.",
	"people-form-email-quantity-exceeded-message": "Adres e-mail musi być unikalny.",
	"receipt-notification-order-details-subtotal": "Suma cząstkowa",
	"shared-entry-edit-link": "Edytuj wpis.",
	"receipt-notification-trx-details-header": "Szczegóły transakcji",
	"address-city": "Miasto",
	"receipt-notification-order-details-amount-paid": "Kwota zapłacona",
	"credit-card-invalid": "Karta jest nieważna.",
	"format-decimal": "####,##",
	"entry-notification-new-submission-text": "Masz nowe zgłoszenie.",
	"this-and-that": "{0} i {1}",
	"field-ratingscale-good-poor-label": "Dobrze/Źle",
	"network-unavailable-message": "Sieć niedostępna, spróbuj ponownie później.",
	"dialog-close": "Zamknąć",
	"string-format-alphanumeric": "{property} musi zawierać tylko litery i cyfry.",
	"credit-card": "Karta kredytowa",
	"remove-item": "Usunąć {item}",
	"receipt-notification-order-details-price-header": "Cena",
	"fileupload-upload-inprogress-message": "Wysyłka pliku w toku.",
	"public-terms-of-service-link-text": "Warunki korzystania z usługi",
	"save-and-resume-email-subject": "Zapisz \u0026 Resume link",
	"field-repeatingsection-remove-link-text": "Usunąć",
	"field-ratingscale-na-label": "N/A",
	"add-item": "Dodaj {item}",
	"field-toggle-options": "Tak/Nie|Prawda/Fałsz|Otwarty/Zamkniety|Aktywne/Nieaktywne|Przeczytane/Nieprzeczytane",
	"order-submit-timeout": "Realizacja zamówienia trwa zbyt długo. Prosimy spróbować później zamówienia.",
	"listlength-at-most": "Proszę podać nie więcej niż {max} {property}.",
	"shared-entry-email-view-message": "Użyj poniższego linku, aby zobaczyć wspólny wpis.",
	"order-number-label": "Numer",
	"card-declined": "Karta odrzucona",
	"fileupload-default-upload-button-text": "Wyślij",
	"name-prefix": "Tytuł",
	"address-line2": "Linia adresu 2",
	"element-label-email": "Adres e-mail",
	"field-ratingscale-good-poor-options": "Bardzo źle|Źle|Średnio|Dobrze|Bardzo dobrze",
	"next-button-text": "Następna strona",
	"question": "Pytanie",
	"address-postalcode": "Pocztowy / kod pocztowy",
	"format-with-description": "{property} musi być sformatowany jako {description}.",
	"field-datepicker-prev-month": "Poprzedni miesiąc",
	"name": "Nazwa",
	"receipt-notification-order-details-total-footer": "Ogółem",
	"confirmation-message": "Dziękujemy za wypełnienie formularza. Odpowiedzi zostały zarejestrowane.",
	"shared-entry-email-edit-message": "Użyj poniższego linku, aby edytować wspólną pozycję.",
	"field-default-label": "Bez tytułu",
	"required-value": "{property} musi być {value}.",
	"name-middle": "Drugię imię",
	"fileupload-failed-upload-message": "{fileName} nie udało się przesłać.",
	"shared-entry-email-button-label": "Zobacz wpis",
	"field-datepicker-year": "rok",
	"element-label-phone": "Telefon",
	"TRUE": "Prawda.",
	"listlength-between": "Proszę określić, od {min} do {max} {property}.",
	"marketing-button-1": "Spróbuj Teraz",
	"entry-submission-error-heading": "Błąd przetwarzania wpisu",
	"order-not-found-message": "Nie znaleziono informacji o zamówieniu.",
	"format-without-description": "{property} nie jest sformatowany poprawnie.",
	"name-last": "Nazwisko ",
	"field-ratingscale-one-five-label": "Skala 1 do 5",
	"listlength-at-least": "Proszę podać co najmniej {min} {property}.",
	"united-states": "Stany Zjednoczone",
	"field-signature-captured": "Schwytany",
	"compare-on-or-before": "{property} musi być w lub przed {compareSource}.",
	"order-balance-due-label": "Saldo do zapłaty",
	"required-if-less-than": "{property} jest wymagane, gdy {compareValue} jest mniejsze niż {compareSource}.",
	"credit-card-postalcode": "Pocztowy",
	"form-not-available-message": "Ten formularz nie jest obecnie dostępny.",
	"element-label-address": "Adres",
	"receipt-notification-trx-details-number": "Numer",
	"public-submission-warning": "",
	"save-and-resume-no-expiration-email-message": "Użyj poniższego linku, aby wrócić do formy, aby zakończyć składanie.",
	"fileupload-excluded-file-type-message": "Pliki tego typu nie mogą być przesłane.",
	"payment-subtotal": "Suma cząstkowa",
	"collapse": "Zwinąć",
	"save-button-text": "Zapisz",
	"field-datepicker-prev-year": "Poprzedni rok",
	"signature-type": "wpisać",
	"order-amount-minimum": "Kwota należności musi wynosić co najmniej 1,00 złoty.",
	"string-format-numeric": "{property} musi zawierać tylko cyfry.",
	"entry-confirmation-entry-details-header": "Szczegóły wpisu",
	"connected-to-venmo": "Połączony z Venmo.",
	"format-percentage": "#,##%",
	"receipt-notification-header": "Paragon ",
	"clear": "Wyczyść",
	"today": "Dzisiaj",
	"required-name-last": "Nazwisko jest wymagane.",
	"marketing-button-3": "Spróbuj Teraz",
	"expand": "Rozwinąć",
	"compare-greater-than": "{property} musi być większa niż {compareSource}.",
	"field-ratingscale-will-wont-label": "Tak/Nie",
	"required-name-first": "Imię jest wymagane.",
	"save-and-resume-one-day-expiration-message": "Kopiowanie lub e-mail link poniżej i powrót do formularza w ciągu następnego dnia aby zakończyć twoje zgłoszenie.",
	"required-asterisk": "wymagane",
	"credit-card-required": "Wymagana jest karta kredytowa.",
	"address-state-province-region": "Województwo / Powiat / Gmina",
	"save-and-resume-email-sent-message": "E-mail został wysłany.",
	"workflow-action": "Akcja",
	"field-ratingscale-will-wont-options": "Zdecydowanie nie|Prawdopodobnie nie|Nie jestem pewien|Prawdopodobnie tak|Zdecydowanie tak",
	"save-and-resume-email-label": "Powiadom mnie mój link:",
	"field-ratingscale-agree-disagree-options": "Zdecydowanie sie nie zgadzam|Nie zgadzam sie|Wszystko jedno|Zgadzam sie|Zdecydowanie zgadzam się",
	"order-exception-order-already-paid": "Ten porządek został zapłacony.",
	"fileupload-download-text": "Pobierz",
	"address-state": "Województwo",
	"allowed-values": "{property} nie jest na liście dozwolonych wartości.",
	"shared-entry-workflow-email-button-label": "Otwórz formularz",
	"compare-equal": "{property} musi być taka sama jak {compareSource}.",
	"field-datepicker-clear": "Wyczyść",
	"name-first": "Imię ",
	"save-and-resume-message": "Formularz został zapisany",
	"save-and-resume-no-expiration-message": "Kopiowanie lub e-mail link poniżej i powrót do formularza aby zakończyć twoje zgłoszenie.",
	"entry-notification-view-details-text": "Zobacz szczegóły",
	"order-exception-default-message": "Nie można przetworzyć transakcji.",
	"public-report-abuse-link-text": "Zgłoś nadużycie",
	"order-amount-paid": "Kwota zapłacona",
	"element-label-default": "Bez tytułu",
	"countries": "Afganistan | Afryka Południowa | Albania | Algieria | Andora | Angola | Anguilla | Antarctica | Antigua i Barbuda | Antyle Holenderskie | Arabia Saudyjska | Argentyna | Armenia | Aruba | Australia | Austria | Azerbejdżan | Bahamy | Bahrajn | Bangladesz | Barbados | Belgia | Belize | Benin | Bermudy | Bhutan | Białoruś | Boliwia | Bośnia i Hercegowina | Botswana | Brazylia | Brunei Darussalam | Bułgaria | Burkina Faso | Burundi | Chile | Chiny | Chorwacja | Cocos ( Keeling) Wyspy | Cypr | Czad | Czarnogóra | Czechy | Dania | Demokratyczna Republika Konga (Kinshasa) | Dominika | Dominikana | Dżibuti | Egipt | Ekwador | El Salvador | Erytrea | Estonia | Etiopia | Falklandy | Federacja Rosyjska | Fidżi | Filipiny | Finlandia | Francja | Francuskie Terytoria Południowe | Gabon | Gambia | Ghana | Gibraltar | Grecja | Grenada | Grenlandia | Gruzja | Guam | Gujana | Gujana Francuska | Gwadelupa | Gwatemala | Gwinea | Gwinea Bissau | Gwinea Równikowa | Haiti | Hiszpania | Holandia | Honduras | Hongkong | Indie | Indonezja | Irak | Iran (Islamska Republika) | Irlandia | Islandia | Izrael | Jamajka | Japonia | Jemen | Jordania | Kajmany | Kambodża | Kamerun | Kanada | Katar | Kazachstan | Kenia | Kirgistan | Kiribati | Kolumbia | Komory | Kongo, Republika (Brazzaville) | Korea Południowa (Republika Korei) | Korea, Demokratyczna Republika Ludowa (Korea Północna) | Kosowo | Kostaryka | Kuba | Kuwejt | Lao, Republika Ludowo-Demokratyczna | Lesotho | Liban | Liberia | Libia | Liechtenstein | Litwa | Łotwa | Luksemburg | Republika Macedonii Północnej | Madagaskar | Makau | Malawi | Malediwy | Malezja | Mali | Malta | Mariany Północne | Maroko | Martinique | Mauretania | Mauritius | Mayotte | Meksyk | Mikronezja, Federalne Stany | Mołdawii, Republiki | Monako | Mongolia | Montserrat | Mozambik | Myanmar, Birma | Namibia | Nauru | Nepal | Niemcy | Niger | Nigeria | Nikaragua | Niue | Norwegia | Nowa Kaledonia | Nowa Zelandia | Oman | Pakistan | Palau | Panama | Państwo Watykańskie (Stolica Apostolska) | Papua Nowe Gwinea | Paragwaj | Peru | Pitcairn Island | Polinezja Francuska | Polska | Portoryko | Portugalia | Republika Środkowoafrykańska | Republika Zielonego Przylądka | Rumunia | Rwanda | Sahara Zachodnia | Saint Kitts i Nevis | Saint Lucia | Saint Vincent i Grenadyny | Samoa | Samoa Amerykańskie | San Marino | Senegal | Serbia | Seszele | Sierra Leone | Singapur | Słowacja (Słowacja) | Słowenia | Somalia | Sri Lanka | Stany Zjednoczone | Stolica Apostolska | Suazi | Sudan | Sudan Południowy | Surinam | Syria, Syryjska Republika Arabska | Szwajcaria | Szwecja | Tadżykistan | Tajlandia | Tajwan (Republika Chińska) | Tanzania; oficjalnie Zjednoczone Królestwo Tanzanii | Terytoria Palestyńskie | Timor-Leste (Timor Wschodni) | Togo | Tokelau | Tonga | Trynidad i Tobago | Tunezja | Turcja | Turkmenistan | Tuvalu | Tybet | Uganda | Ukraina | Urugwaj | Uzbekistan | Vanuatu | Węgry | Wenezuela | Wielka Brytania | Wietnam | Włochy | Wschodnia Timor (Timor-Leste) | Wybrzeże Kości Słoniowej | Wyspa Bożego Narodzenia | Wyspa Man |Wyspa Reunion | Wyspy Cooka | Wyspy Dziewicze (Brytyjskie) | Wyspy Dziewicze (USA) | Wyspy Marshalla | Wyspy Owcze | Wyspy Salomona | Wyspy Świętego Tomasza i Książęca | Wyspy Turks i Caicos | Wyspy Wallis i Futuna | Zambia | Zimbabwe | Zjednoczone Emiraty Arabskie | Zjednoczone Królestwo",
	"name-middleinitial": "Inicjał drugiego imienia",
	"order-exception-empty-order": "Zamówienie musi zawierać co najmniej 1 pozycję.",
	"compare-not-equal": "{property} musi się różnić od {compareSource}.",
	"entry-notification-footer": "Otrzymujesz tą wiadomość, ponieważ wybrano opcję „Odbierz powiadomienie e-mail” w formularzu w Cognito.",
	"save-and-resume-copy-link-label": "Skopiuj link do formularza:",
	"entry-confirmation-footer": "Otrzymujesz ten e-mail, ponieważ została ukończona transakcja z",
	"required-if-on-or-before": "{property} jest wymagane, gdy przed {compareValue} lub {compareSource}.",
	"string-format": "{property} musi być sformatowany jako {formatDescription}."
};
